<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">

    <defs>
        <g id="piece">
            <path d="M 0 25 v 15 a 40 25, 0, 0, 0, 80 0 v -15 a 40 25, 0, 0, 0, -80 0 Z"/>
            <ellipse cx="40"
                     cy="25"
                     rx="40"
                     ry="25"/>
        </g>
    </defs>

    <!-- Empty board -->
    @for (coordAndContent of constructedState().get().getCoordsAndContents(); track coordAndContent.coord.toString()) {
        <polygon id="square-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                 [attr.transform]="getTranslationAtXYZ(coordAndContent.coord.x, coordAndContent.coord.y, 0)"
                 (click)="onClick(coordAndContent.coord.x, coordAndContent.coord.y)"
                 [attr.points]="parallelogramPoints()"
                 [ngClass]="getSquareClass(coordAndContent.coord.x, coordAndContent.coord.y)"
                 class="base"/>
    }

    <rect id="bottomEdge"
          x="0"
          [attr.y]="basicHeight()"
          [attr.width]="basicWidth() * mode().horizontalWidthRatio"
          [attr.height]="THICKNESS"
          class="base"/>
    <polygon id="rightEdge"
             [attr.points]="rightEdge()"
             class="base"/>

    <!-- Clickable highlights -->
    @for (coord of possibleClicks; track coord.toString()) {
        <polygon id="clickable-highlight-{{ coord.x }}-{{ coord.y }}"
                 [attr.transform]="getTranslationAtXYZ(coord.x, coord.y, 0)"
                 (click)="onClick(coord.x, coord.y)"
                 [attr.points]="parallelogramPoints()"
                 class="base no-fill clickable-stroke small-stroke"/>
    }

    <!-- Pieces -->
    @for (coordAndContent of constructedState().get().getCoordsAndContents(); track coordAndContent.coord.toString()) {
        <g id="coord-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
           [attr.transform]="getTranslationAtXYZ(coordAndContent.coord.x, coordAndContent.coord.y, 0)"
           (click)="onClick(coordAndContent.coord.x, coordAndContent.coord.y)">
            @for (pieceInfo of coordAndContent.content.pieces; track $index; let z = $index) {
                <g pointer-events="fill"
                   [attr.transform]="getPieceTranslation(z)"
                   class="base mid-small-stroke">
                    <use id="square-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}-piece-{{ z }}"
                         xlink:href="#piece"
                         [ngClass]="getPieceClasses(coordAndContent.coord.x, coordAndContent.coord.y, z)"
                         class="base mid-stroke"/>
                    @if (isPiecePromoted(coordAndContent.coord.x, coordAndContent.coord.y, z)) {
                        <circle id="square-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}-piece-{{ z }}-promoted-symbol"
                                [attr.cx]="SPACE_SIZE * 0.4"
                                [attr.cy]="SPACE_SIZE * 0.575"
                                [attr.r]="SPACE_SIZE * 0.045"
                                [ngClass]="getPieceClasses(coordAndContent.coord.x, coordAndContent.coord.y, z)"/>
                    }
                </g>
            }
        </g>
    }

</svg>
